import React from 'react';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import styles from 'assets/jss/material-dashboard-pro-react/layouts/registerStyle';
import RegisterPage from 'views/Auth/RegisterPage';

// @ts-ignore
const useStyles = makeStyles(styles);

const Register = () => {
	const classes = useStyles();

	return (
		<div className={classNames([classes.wrapper, classes.responsiveBackground])}>
			<RegisterPage />
		</div>
	);
};

export default Register;
